import FavouritesDashboardActionTypes from './favouritesDashboard-types'

export const addAssetSelectionToFavourites = data => ({
    type: FavouritesDashboardActionTypes.ADD_SELECTION,
    payload: data,
})

export const removeAssetSelectionFromFavourites = data => ({
    type: FavouritesDashboardActionTypes.REMOVE_SELECTION,
    payload: data,
})

export const closeDashboardSectionsSideNav = data => ({
    type: FavouritesDashboardActionTypes.CLOSE_SECTIONS_SIDE_NAV,
    payload: data,
})

export const addAssetToFavourites = data => ({
    type: FavouritesDashboardActionTypes.ADD_ASSET_TO_FAVOURITES,
    payload: data,
})

export const removeAssetFromFavourites = data => ({
    type: FavouritesDashboardActionTypes.REMOVE_ASSET_FROM_FAVOURITES,
    payload: data,
})

export const removeMultipleAssetsFromFavourites = data => ({
    type: FavouritesDashboardActionTypes.REMOVE_MULTIPLE_ASSETS_FROM_FAVOURITES,
    payload: data,
})

export const startFetchAllFavourites = data => ({
    type: FavouritesDashboardActionTypes.START_FETCH_ALL_FAVOURITES,
    payload: data,
})

export const successFetchAllFavourites = data => ({
    type: FavouritesDashboardActionTypes.SUCCESS_FETCH_ALL_FAVOURITES,
    payload: data,
})

export const clearSelectedAssets = data => ({
    type: FavouritesDashboardActionTypes.CLEAR_SELECTED_ASSETS,
    payload: data,
})
